module.exports = __webpack_public_path__ + "img/undraw_Hiking_re_k0bc.87687cce.svg";